import { EntityState, EntityStateAdapter } from './models';

export function createStateOperator<V, R>(
  mutator: (arg: R, state: EntityState<V>) => boolean
): EntityState<V>;
/**
 * @template V, R
 * @param {?} mutator
 * @return {?}
 */
export function createStateOperator<V, R>(
  mutator: (arg: any, state: any) => boolean
): any {
  return function operation<S extends EntityState<V>>(arg: R, state: any): S {
    const /** @type {?} */ clonedEntityState: EntityState<V> = {
      ids: [...state.ids],
      entities: { ...state.entities },
    };

    const /** @type {?} */ didMutate = mutator(arg, clonedEntityState);

    if (didMutate) {
      return Object.assign({}, state, clonedEntityState);
    }

    return state;
  };
}



// WEBPACK FOOTER //
// ../../../modules/entity/src/state_adapter.ts